/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductMappingRequestModel } from '../../models/product-mapping-request-model';

export interface GetProductMappingRequest$Params {
  productMappingRequestId: string;
}

export function getProductMappingRequest(http: HttpClient, rootUrl: string, params: GetProductMappingRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductMappingRequestModel>> {
  const rb = new RequestBuilder(rootUrl, getProductMappingRequest.PATH, 'get');
  if (params) {
    rb.path('productMappingRequestId', params.productMappingRequestId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/problem+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductMappingRequestModel>;
    })
  );
}

getProductMappingRequest.PATH = '/product-mappings/request/{productMappingRequestId}';
